<ng-container [formGroup]="form">
  <input type="hidden" formControlName="complete" name="complete">
  <div class="field-wrapper">
    <div id="card-element" class="input-element empty" #card></div>
  </div>
</ng-container>
